import api from "../apis/AuthApi";
import axios from "axios";
import * as constant from "../constants/PlanConstants";


export const DeleteAccount = async(data,onSuccess,onError) =>{
  api
  .Authontication()
  .deleteAccount(data)
  .then((res) => {
    console.log(res.data);
    onSuccess()
  })
  .catch((err) => {
    if (err.code === 'ECONNABORTED'){
      console.log("Timeout");
    }else{

  console.log(err)
  console.log(err.response)
  onError(err.response.data.message)
    }
  });
}

//Check user sync with website or not
export const SyncORnot = (data) => (dispatch) => {
  api
    .Authontication()
    .syncORnot(data)
    .then((res) => {
      console.log(res.data);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        console.log("Timeout");
      }else{
      console.log(err.response);
      
      }
    });
};

export const QuickSignupUser = (data, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .quickSignup(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

//Submit session feedback
export const Feedback = (data, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .Feedback(data)
    .then((res) => {
      console.log(res.data);
      onSuccess();
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

//submit feedback about platform (expirience)
export const FeedbackLearner = (data, onSuccess, onError) => (dispatch) => {
  console.log(data);
  api
    .Authontication()
    .FeedbackLearner(data)
    .then((res) => {
      console.log(res.data);
      onSuccess();
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};


//Register Number
export const NumberRegister = (data, onSuccess, onError) => (dispatch) => {
  console.log(data);
  api
    .Authontication()
    .NumberRegister(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

//Number Verify
export const NumberVerify = (data, onSuccess, onError) => (dispatch) => {
  console.log(data);
  api
    .Authontication()
    .NumberVerify(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

//Policy Accepted
export const PolicyAccepted = (data, onSuccess, onError) => (dispatch) => {
  console.log(data);
  api
    .Authontication()
    .PolicyAccepted(data)
    .then((res) => {
      console.log(res);
      onSuccess(res);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};


//SIGNUP LEARNER
export const Signup = (signupdata, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .Signup(signupdata)
    .then((res) => {
      console.log(res.data.message);
      onSuccess(res.data.message, res.data.statusCode);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
      }
    });
};


//SIGNUP WITHOUT OTP
export const SignupWithoutOtp = (signupdata, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .SignupWithoutOtp(signupdata)
    .then((res) => {
      console.log(res.data.message);
      onSuccess(res);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

//Verify otp
export const VerifyOtp = (otp, onSuccess, onError, bookdemo) => (dispatch) => {
  console.log(otp);
  api
    .Authontication()
    .VerifyOtp(otp)
    .then((res) => {
      if (bookdemo === true) {
        localStorage.removeItem("IS_LOGOUT");
        localStorage.setItem("USER", JSON.stringify(res.data.learner));
        localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
        localStorage.setItem("LOGIN", JSON.stringify("true"));
        localStorage.setItem("IS_LOGOUT", JSON.stringify(true));
        localStorage.setItem("ROLE", JSON.stringify("Learner"));
      } else {
        localStorage.setItem("DATA", JSON.stringify(res.data.learner));
      }

      onSuccess(res);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const VerifyOtpV1 = (otp, onSuccess, onError, bookdemo) => (dispatch) => {
  console.log(otp);
  api
    .Authontication()
    .verifyOTPV1(otp)
    .then((res) => {
      if (bookdemo === true) {
        localStorage.removeItem("IS_LOGOUT");
        localStorage.setItem("USER", JSON.stringify(res.data.learner));
        localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
        localStorage.setItem("LOGIN", JSON.stringify("true"));
        localStorage.setItem("IS_LOGOUT", JSON.stringify(true));
        localStorage.setItem("ROLE", JSON.stringify("Learner"));
      } else {
        localStorage.setItem("DATA", JSON.stringify(res.data.learner));
      }

      onSuccess(res);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

//Resend otp
export const ResendOtp = (number, onSuccess, onError) => (dispatch) => {
  console.log(number);
  api
    .Authontication()
    .ResendOtp(number)
    .then((res) => {
      onSuccess();
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const ResendOtpV1 = (number, onSuccess, onError) => (dispatch) => {
  console.log(number);
  api
    .Authontication()
    .resendOtpV1(number)
    .then((res) => {
      onSuccess();
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

//Set password
export const Setpassword = (data, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .setPassword(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data.message);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

//Login LEARNER
export const learnerLogin = (data, onSuccess, onError) => (dispatch) => {
  console.log(data);
  api
    .Authontication()
    .Login(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data);
      localStorage.setItem("USER", JSON.stringify(res.data.learner));
      localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
    })
    .catch((err) => {
      console.log(err.response);
      if (err.response) {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
      }
    });
};

//sosial authontication
export const SosialAuth = (data, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .Sosialauth(data)
    .then((res) => {
      // console.log(res.data);
      dispatch({
        type: constant.LOAD_USER,
        payload: res.data.learner,
      });
      console.log("social login success")
      console.log(res.data.learner.token)
      localStorage.setItem("LOGIN", JSON.stringify("true"));
      localStorage.setItem("ROLE", JSON.stringify("Learner"));
      localStorage.setItem("USER", JSON.stringify(res.data.learner));
      localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
      localStorage.setItem("IS_LOGOUT", true);
      localStorage.removeItem("DATA");
      onSuccess(res.data);
    })
    .catch((err) => {
      // console.log(err);
      // console.log("social login failed")
      if (err.response) {
        
      } else {
        onError("Please reload & try again");
      }
    });
};

//check user have password or not
export const AskOtpPassword = (data, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .AskOtpOrPassword(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data.message, res.data.statusCode);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{

      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const AskOtp = (data, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .AskOtp(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data.message, res.data.statusCode);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{

      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const AskOtpV1 = (data, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .askOTPV1(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data.message, res.data.statusCode);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{

      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const SetupLearner = (data, onSuccess, onError) => (dispatch) => {
  api
    .Authontication()
    .SetupLearner(data)
    .then((res) => {
      console.log(data)
      console.log(res.data);
      onSuccess(res.data.message);
    })
    .catch((err) => {
      console.log(data)
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{

      console.log(err.response);
      onError(err.response);
      }
    });
};


export const GetLearner = (data) => (dispatch) => {
  api
    .Authontication()
    .getLearner(data)
    .then((res) => {
      console.log(res);

      if(res.data.statusCode === 200){
      localStorage.setItem("USER", JSON.stringify(res.data.learner));
      localStorage.setItem("USERRES", JSON.stringify(res));
      if (JSON.parse(localStorage.getItem("REMOVE"))) {
        localStorage.removeItem("USER");
        localStorage.removeItem("REMOVE");
        window.location.reload();
      }
    }
      //   dispatch({
      //       type: "FETCH_ALL",
      //       payload: res.data
      //   })
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        console.log("Timeout");
      }else{
      console.log(err.response);
      
      }
    });
};

//forgot password
export const LearnerForgotPassword =
  (data, onSuccess, onError) => (dispatch) => {
    console.log(data);
    api
      .Authontication()
      .Forgotpassword(data)
      .then((res) => {
        console.log(res.data);
        onSuccess(res.data.message);
      })
      .catch((err) => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
      });
  };

//setup learner
// export const SetupLearner = (data, onSuccess, onError) => (dispatch) => {
//   var postData = {
//     learner: data.details.learner,
//     name: data.details.name,
//     city: data.details.city,
//     profession: data.details.profession,
//     currentLevel: data.details.currentLevel,
//     emailorphone: data.details.emailOrPhonenumber,
//     referal: data.details.referal,
//   };

//   let axiosConfig = {
//     headers: {
//       "x-access-token": data.token,
//     },
//   };

//   axios
//     .put(
//       `${process.env.REACT_APP_BASE_URL}/api/learner/v1/setupLearner`,
//       postData,
//       axiosConfig
//     )
//     .then(function (response) {
//       console.log(response);
//       onSuccess(response.data.message, response.data.statusCode);
//     })
//     .catch(function (error) {
//       if (error.code === 'ECONNABORTED'){
//         onError("Timeout");
//       }else{
//       onError(error.response);
//       }
//     });
// };

//get learner session document

export const getNotes = (data, onSuccess) => (dispatch) => {
  api
    .Authontication()
    .GetNotes(data)
    .then((res) => {
      console.log(res.data);
      dispatch({
        type: constant.GET_NOTES,
        payload: res.data,
      });
    })
    .catch((err) => {
            if (err.code === 'ECONNABORTED'){
        console.log("Timeout");
      }else{
      console.log(err.response);
      
      }
    });
};

//LOAD USER
export const relode = (data) => (dispatch) => {
  dispatch({
    type: constant.LOAD_USER,
    payload: data,
  });
};

//update LEARNER password
export const UpdatePassword = (data, onSuccess, onError) => (dispatch) => {
  console.log(data);
  api
    .Authontication()
    .updatePassword(data)
    .then((res) => {
      console.log(res.data);
      localStorage.setItem("LOGIN", JSON.stringify("true"));
      localStorage.setItem("ROLE", JSON.stringify("Teacher"));
      onSuccess();
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};
